// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.notification-bell-container {
  position: relative;
  display: inline-block;
}

.notification-bell-button {
  position: relative;
  background: none;
  border: none;
  cursor: pointer;
  padding: 8px;
  border-radius: 50%;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
}

.notification-bell-button:hover {
  background: rgba(255, 255, 255, 0.1);
}

.bell-icon {
  font-size: 20px;
  filter: drop-shadow(0 1px 2px rgba(0, 0, 0, 0.1));
}

.notification-badge {
  position: absolute;
  top: 2px;
  right: 2px;
  background: linear-gradient(135deg, #ff6b6b 0%, #ee5a24 100%);
  color: white;
  border-radius: 10px;
  padding: 2px 6px;
  font-size: 11px;
  font-weight: 700;
  min-width: 18px;
  height: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  animation: pulse 2s infinite;
}

@keyframes pulse {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.1);
  }
  100% {
    transform: scale(1);
  }
}

.notification-dropdown {
  position: absolute;
  top: 100%;
  right: 0;
  width: 380px;
  max-width: 90vw;
  background: white;
  border-radius: 12px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.15);
  border: 1px solid #e9ecef;
  z-index: 1000;
  overflow: hidden;
  animation: slideDown 0.2s ease-out;
}

@keyframes slideDown {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.notification-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 20px;
  border-bottom: 1px solid #f0f0f0;
  background: #f8f9fa;
}

.notification-header h3 {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: #2c3e50;
}

.mark-all-read-btn {
  background: none;
  border: none;
  color: #007bff;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  padding: 4px 8px;
  border-radius: 4px;
  transition: all 0.2s ease;
}

.mark-all-read-btn:hover {
  background: #e3f2fd;
  color: #0056b3;
}

.notification-list {
  max-height: 400px;
  overflow-y: auto;
}

.notification-loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 40px 20px;
  color: #6c757d;
}

.loading-spinner.small {
  width: 24px;
  height: 24px;
  border: 2px solid #f3f3f3;
  border-top: 2px solid #007bff;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin-bottom: 12px;
}

.no-notifications {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 40px 20px;
  text-align: center;
  color: #6c757d;
}

.no-notifications-icon {
  font-size: 32px;
  margin-bottom: 12px;
  opacity: 0.7;
}

.no-notifications p {
  margin: 0 0 8px 0;
  font-size: 16px;
  font-weight: 500;
  color: #495057;
}

.no-notifications span {
  font-size: 14px;
  color: #6c757d;
}

.notification-item {
  position: relative;
  display: flex;
  align-items: flex-start;
  padding: 16px 20px;
  border-bottom: 1px solid #f0f0f0;
  cursor: pointer;
  transition: all 0.2s ease;
  gap: 12px;
}

.notification-item:hover {
  background: #f8f9fa;
}

.notification-item:last-child {
  border-bottom: none;
}

.notification-item.unread {
  background: linear-gradient(90deg, #e3f2fd 0%, #f8f9fa 100%);
  border-left: 4px solid #007bff;
}

.notification-icon {
  font-size: 20px;
  margin-top: 2px;
  flex-shrink: 0;
}

.notification-content {
  flex: 1 1;
  min-width: 0;
}

.notification-title {
  font-size: 14px;
  font-weight: 600;
  color: #2c3e50;
  margin-bottom: 4px;
  line-height: 1.3;
}

.notification-message {
  font-size: 13px;
  color: #6c757d;
  line-height: 1.4;
  margin-bottom: 6px;
  word-wrap: break-word;
}

.notification-time {
  font-size: 12px;
  color: #adb5bd;
  font-weight: 500;
}

.delete-notification-btn {
  position: absolute;
  top: 12px;
  right: 12px;
  background: none;
  border: none;
  color: #adb5bd;
  font-size: 18px;
  cursor: pointer;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
  opacity: 0;
}

.notification-item:hover .delete-notification-btn {
  opacity: 1;
}

.delete-notification-btn:hover {
  background: #f8d7da;
  color: #dc3545;
}

.unread-indicator {
  position: absolute;
  top: 50%;
  right: 8px;
  transform: translateY(-50%);
  width: 8px;
  height: 8px;
  background: #007bff;
  border-radius: 50%;
  box-shadow: 0 0 0 2px white;
}

.notification-footer {
  padding: 12px 20px;
  border-top: 1px solid #f0f0f0;
  background: #f8f9fa;
  text-align: center;
}

.view-all-btn {
  background: none;
  border: none;
  color: #007bff;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  padding: 8px 16px;
  border-radius: 6px;
  transition: all 0.2s ease;
  width: 100%;
}

.view-all-btn:hover {
  background: #e3f2fd;
  color: #0056b3;
}

/* Mobile-specific notification dropdown */
.notification-dropdown-mobile {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: white;
  z-index: 2000;
  display: flex;
  flex-direction: column;
  animation: slideInFromTop 0.3s ease-out;
}

@keyframes slideInFromTop {
  from {
    opacity: 0;
    transform: translateY(-100%);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.notification-header-mobile {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  border-bottom: 1px solid #e9ecef;
  background: #f8f9fa;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.notification-header-mobile h3 {
  margin: 0;
  font-size: 20px;
  font-weight: 600;
  color: #2c3e50;
}

.close-mobile-btn {
  background: #f3f4f6;
  border: none;
  border-radius: 50%;
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-size: 20px;
  color: #6b7280;
  transition: all 0.2s ease;
}

.close-mobile-btn:hover {
  background: #e5e7eb;
  color: #374151;
}

.notification-list-mobile {
  flex: 1 1;
  overflow-y: auto;
  padding: 0;
}

.notification-item-mobile {
  display: flex;
  align-items: flex-start;
  padding: 16px 20px;
  border-bottom: 1px solid #f0f0f0;
  cursor: pointer;
  transition: all 0.2s ease;
  gap: 12px;
  position: relative;
}

.notification-item-mobile:hover {
  background: #f8f9fa;
}

.notification-item-mobile:last-child {
  border-bottom: none;
}

.notification-item-mobile.unread {
  background: linear-gradient(90deg, #e3f2fd 0%, #f8f9fa 100%);
  border-left: 4px solid #007bff;
}

.notification-footer-mobile {
  padding: 16px 20px;
  border-top: 1px solid #e9ecef;
  background: #f8f9fa;
}

.mark-all-read-btn-mobile {
  width: 100%;
  background: #007bff;
  border: none;
  border-radius: 8px;
  padding: 12px 16px;
  color: white;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
}

.mark-all-read-btn-mobile:hover {
  background: #0056b3;
}

/* Responsive Design */
@media (max-width: 480px) {
  .notification-bell-container .notification-dropdown {
    position: fixed !important;
    top: 70px !important;
    right: 10px !important;
    left: auto !important;
    width: 300px !important;
    max-width: calc(100vw - 20px) !important;
    transform: none !important;
    margin-left: 0 !important;
  }
  
  .notification-item {
    padding: 12px 16px;
  }
  
  .notification-header {
    padding: 12px 16px;
  }
  
  .notification-footer {
    padding: 8px 16px;
  }
}

@media (max-width: 360px) {
  .notification-bell-container .notification-dropdown {
    width: 280px !important;
    right: 5px !important;
  }
}

/* Extra small screens - full width approach */
@media (max-width: 320px) {
  .notification-bell-container .notification-dropdown {
    width: calc(100vw - 10px) !important;
    left: 5px !important;
    right: 5px !important;
  }
}

/* Custom scrollbar for notification list */
.notification-list::-webkit-scrollbar {
  width: 6px;
}

.notification-list::-webkit-scrollbar-track {
  background: #f1f1f1;
}

.notification-list::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 3px;
}

.notification-list::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
} `, "",{"version":3,"sources":["webpack://./src/components/NotificationBell.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,eAAe;EACf,iDAAiD;AACnD;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,6DAA6D;EAC7D,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,wCAAwC;EACxC,4BAA4B;AAC9B;;AAEA;EACE;IACE,mBAAmB;EACrB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,0CAA0C;EAC1C,yBAAyB;EACzB,aAAa;EACb,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,6BAA6B;EAC7B,kBAAkB;EAClB,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,kBAAkB;EAClB,gCAAgC;EAChC,eAAe;EACf,yBAAyB;EACzB,SAAS;AACX;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,4DAA4D;EAC5D,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,eAAe;EACf,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,2BAA2B;EAC3B,UAAU;EACV,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,0CAA0C;AAC1C;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,iBAAiB;EACjB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,uCAAuC;AACzC;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;EACb,gCAAgC;EAChC,mBAAmB;EACnB,wCAAwC;AAC1C;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,eAAe;EACf,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,kBAAkB;EAClB,gCAAgC;EAChC,eAAe;EACf,yBAAyB;EACzB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,4DAA4D;EAC5D,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA,sBAAsB;AACtB;EACE;IACE,0BAA0B;IAC1B,oBAAoB;IACpB,sBAAsB;IACtB,qBAAqB;IACrB,uBAAuB;IACvB,wCAAwC;IACxC,0BAA0B;IAC1B,yBAAyB;EAC3B;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,uBAAuB;IACvB,qBAAqB;EACvB;AACF;;AAEA,8CAA8C;AAC9C;EACE;IACE,oCAAoC;IACpC,oBAAoB;IACpB,qBAAqB;EACvB;AACF;;AAEA,2CAA2C;AAC3C;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB","sourcesContent":[".notification-bell-container {\n  position: relative;\n  display: inline-block;\n}\n\n.notification-bell-button {\n  position: relative;\n  background: none;\n  border: none;\n  cursor: pointer;\n  padding: 8px;\n  border-radius: 50%;\n  transition: all 0.2s ease;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.notification-bell-button:hover {\n  background: rgba(255, 255, 255, 0.1);\n}\n\n.bell-icon {\n  font-size: 20px;\n  filter: drop-shadow(0 1px 2px rgba(0, 0, 0, 0.1));\n}\n\n.notification-badge {\n  position: absolute;\n  top: 2px;\n  right: 2px;\n  background: linear-gradient(135deg, #ff6b6b 0%, #ee5a24 100%);\n  color: white;\n  border-radius: 10px;\n  padding: 2px 6px;\n  font-size: 11px;\n  font-weight: 700;\n  min-width: 18px;\n  height: 18px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);\n  animation: pulse 2s infinite;\n}\n\n@keyframes pulse {\n  0% {\n    transform: scale(1);\n  }\n  50% {\n    transform: scale(1.1);\n  }\n  100% {\n    transform: scale(1);\n  }\n}\n\n.notification-dropdown {\n  position: absolute;\n  top: 100%;\n  right: 0;\n  width: 380px;\n  max-width: 90vw;\n  background: white;\n  border-radius: 12px;\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.15);\n  border: 1px solid #e9ecef;\n  z-index: 1000;\n  overflow: hidden;\n  animation: slideDown 0.2s ease-out;\n}\n\n@keyframes slideDown {\n  from {\n    opacity: 0;\n    transform: translateY(-10px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.notification-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 16px 20px;\n  border-bottom: 1px solid #f0f0f0;\n  background: #f8f9fa;\n}\n\n.notification-header h3 {\n  margin: 0;\n  font-size: 18px;\n  font-weight: 600;\n  color: #2c3e50;\n}\n\n.mark-all-read-btn {\n  background: none;\n  border: none;\n  color: #007bff;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  padding: 4px 8px;\n  border-radius: 4px;\n  transition: all 0.2s ease;\n}\n\n.mark-all-read-btn:hover {\n  background: #e3f2fd;\n  color: #0056b3;\n}\n\n.notification-list {\n  max-height: 400px;\n  overflow-y: auto;\n}\n\n.notification-loading {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 40px 20px;\n  color: #6c757d;\n}\n\n.loading-spinner.small {\n  width: 24px;\n  height: 24px;\n  border: 2px solid #f3f3f3;\n  border-top: 2px solid #007bff;\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n  margin-bottom: 12px;\n}\n\n.no-notifications {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 40px 20px;\n  text-align: center;\n  color: #6c757d;\n}\n\n.no-notifications-icon {\n  font-size: 32px;\n  margin-bottom: 12px;\n  opacity: 0.7;\n}\n\n.no-notifications p {\n  margin: 0 0 8px 0;\n  font-size: 16px;\n  font-weight: 500;\n  color: #495057;\n}\n\n.no-notifications span {\n  font-size: 14px;\n  color: #6c757d;\n}\n\n.notification-item {\n  position: relative;\n  display: flex;\n  align-items: flex-start;\n  padding: 16px 20px;\n  border-bottom: 1px solid #f0f0f0;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  gap: 12px;\n}\n\n.notification-item:hover {\n  background: #f8f9fa;\n}\n\n.notification-item:last-child {\n  border-bottom: none;\n}\n\n.notification-item.unread {\n  background: linear-gradient(90deg, #e3f2fd 0%, #f8f9fa 100%);\n  border-left: 4px solid #007bff;\n}\n\n.notification-icon {\n  font-size: 20px;\n  margin-top: 2px;\n  flex-shrink: 0;\n}\n\n.notification-content {\n  flex: 1;\n  min-width: 0;\n}\n\n.notification-title {\n  font-size: 14px;\n  font-weight: 600;\n  color: #2c3e50;\n  margin-bottom: 4px;\n  line-height: 1.3;\n}\n\n.notification-message {\n  font-size: 13px;\n  color: #6c757d;\n  line-height: 1.4;\n  margin-bottom: 6px;\n  word-wrap: break-word;\n}\n\n.notification-time {\n  font-size: 12px;\n  color: #adb5bd;\n  font-weight: 500;\n}\n\n.delete-notification-btn {\n  position: absolute;\n  top: 12px;\n  right: 12px;\n  background: none;\n  border: none;\n  color: #adb5bd;\n  font-size: 18px;\n  cursor: pointer;\n  width: 24px;\n  height: 24px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.2s ease;\n  opacity: 0;\n}\n\n.notification-item:hover .delete-notification-btn {\n  opacity: 1;\n}\n\n.delete-notification-btn:hover {\n  background: #f8d7da;\n  color: #dc3545;\n}\n\n.unread-indicator {\n  position: absolute;\n  top: 50%;\n  right: 8px;\n  transform: translateY(-50%);\n  width: 8px;\n  height: 8px;\n  background: #007bff;\n  border-radius: 50%;\n  box-shadow: 0 0 0 2px white;\n}\n\n.notification-footer {\n  padding: 12px 20px;\n  border-top: 1px solid #f0f0f0;\n  background: #f8f9fa;\n  text-align: center;\n}\n\n.view-all-btn {\n  background: none;\n  border: none;\n  color: #007bff;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  padding: 8px 16px;\n  border-radius: 6px;\n  transition: all 0.2s ease;\n  width: 100%;\n}\n\n.view-all-btn:hover {\n  background: #e3f2fd;\n  color: #0056b3;\n}\n\n/* Mobile-specific notification dropdown */\n.notification-dropdown-mobile {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: white;\n  z-index: 2000;\n  display: flex;\n  flex-direction: column;\n  animation: slideInFromTop 0.3s ease-out;\n}\n\n@keyframes slideInFromTop {\n  from {\n    opacity: 0;\n    transform: translateY(-100%);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.notification-header-mobile {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 20px;\n  border-bottom: 1px solid #e9ecef;\n  background: #f8f9fa;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.notification-header-mobile h3 {\n  margin: 0;\n  font-size: 20px;\n  font-weight: 600;\n  color: #2c3e50;\n}\n\n.close-mobile-btn {\n  background: #f3f4f6;\n  border: none;\n  border-radius: 50%;\n  width: 36px;\n  height: 36px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  font-size: 20px;\n  color: #6b7280;\n  transition: all 0.2s ease;\n}\n\n.close-mobile-btn:hover {\n  background: #e5e7eb;\n  color: #374151;\n}\n\n.notification-list-mobile {\n  flex: 1;\n  overflow-y: auto;\n  padding: 0;\n}\n\n.notification-item-mobile {\n  display: flex;\n  align-items: flex-start;\n  padding: 16px 20px;\n  border-bottom: 1px solid #f0f0f0;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  gap: 12px;\n  position: relative;\n}\n\n.notification-item-mobile:hover {\n  background: #f8f9fa;\n}\n\n.notification-item-mobile:last-child {\n  border-bottom: none;\n}\n\n.notification-item-mobile.unread {\n  background: linear-gradient(90deg, #e3f2fd 0%, #f8f9fa 100%);\n  border-left: 4px solid #007bff;\n}\n\n.notification-footer-mobile {\n  padding: 16px 20px;\n  border-top: 1px solid #e9ecef;\n  background: #f8f9fa;\n}\n\n.mark-all-read-btn-mobile {\n  width: 100%;\n  background: #007bff;\n  border: none;\n  border-radius: 8px;\n  padding: 12px 16px;\n  color: white;\n  font-size: 16px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.mark-all-read-btn-mobile:hover {\n  background: #0056b3;\n}\n\n/* Responsive Design */\n@media (max-width: 480px) {\n  .notification-bell-container .notification-dropdown {\n    position: fixed !important;\n    top: 70px !important;\n    right: 10px !important;\n    left: auto !important;\n    width: 300px !important;\n    max-width: calc(100vw - 20px) !important;\n    transform: none !important;\n    margin-left: 0 !important;\n  }\n  \n  .notification-item {\n    padding: 12px 16px;\n  }\n  \n  .notification-header {\n    padding: 12px 16px;\n  }\n  \n  .notification-footer {\n    padding: 8px 16px;\n  }\n}\n\n@media (max-width: 360px) {\n  .notification-bell-container .notification-dropdown {\n    width: 280px !important;\n    right: 5px !important;\n  }\n}\n\n/* Extra small screens - full width approach */\n@media (max-width: 320px) {\n  .notification-bell-container .notification-dropdown {\n    width: calc(100vw - 10px) !important;\n    left: 5px !important;\n    right: 5px !important;\n  }\n}\n\n/* Custom scrollbar for notification list */\n.notification-list::-webkit-scrollbar {\n  width: 6px;\n}\n\n.notification-list::-webkit-scrollbar-track {\n  background: #f1f1f1;\n}\n\n.notification-list::-webkit-scrollbar-thumb {\n  background: #c1c1c1;\n  border-radius: 3px;\n}\n\n.notification-list::-webkit-scrollbar-thumb:hover {\n  background: #a8a8a8;\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
